import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { COMMON_CONFIG } from '../../tokens/common-config.token';

export const whiteLabelClientInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const { whiteLabelClient } = inject(COMMON_CONFIG);

  if (!whiteLabelClient) {
    return next(request);
  }

  const updatedRequest = request.clone({
    setHeaders: { 'wl-client': whiteLabelClient },
  });
  return next(updatedRequest);
};
